<template>
  <modal
    :title="title"
    :width="600"
    :disabled="!isFormValid"
    :saving="saving"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSubmit"
  >
    <div>
      <Table>
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">Qty</th>
            <th>Task</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center">{{ lineItem.quantity }}</td>
            <td class="whitespace-normal">{{ lineItem.unit_name }}</td>
          </tr>
        </tbody>
      </Table>
      <div>
        Enter a new sold task time to calculate the total sold time for this
        invoice.
      </div>
      <div class="d-flex form-cont mb-3">
        <div class="d-flex flex-column align-items-center flex-1 p-2">
          <span class="font-bold">Current Sold Task Time:</span>
          <div class="current-time-label">
            <minutes-label
              :minutes="lineItem.unit_time_minutes"
            ></minutes-label>
            x {{ lineItem.quantity }} Qty =
            <minutes-label :minutes="currentTotalSoldTime"></minutes-label>
          </div>
        </div>
        <divider class="mx-2" vertical></divider>
        <div class="d-flex flex-column align-items-center flex-1 p-2">
          <span class="font-bold">New Sold Task Time:</span>
          <div class="d-flex align-items-center mt-1 gap-2">
            <div class="flex items-center gap-1">
              <text-field
                v-model.number="hours"
                type="number"
                class="time-input"
              ></text-field>
              hrs
            </div>
            <div class="flex items-center gap-1">
              <text-field
                v-model.number="minutes"
                type="number"
                class="time-input"
              ></text-field>
              m
            </div>
            <div>
              x {{ lineItem.quantity }} Qty =
              <minutes-label :minutes="newTotalSoldTime"></minutes-label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="lineItemLink">
        If you need to update the time required for this task for previous or
        new invoices, please use the
        <Link :to="lineItemLink">task section in the Pricebook.</Link>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from "vuex";
import { isFalsy } from "@/lib/helpers.js";

import Divider from "@/components/Divider.vue";
import Link from "@/components/Link.vue";
import MinutesLabel from "@/components/MinutesLabel.vue";
import Modal from "@/components/Modal.vue";
import Table from "@/components/Table.vue";
import TextField from "@/components/TextField.vue";

export default {
  components: {
    Modal,
    Table,
    Link,
    Divider,
    MinutesLabel,
    TextField
  },
  props: {
    invoiceId: {
      type: Number,
      default: null
    },
    lineItem: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      hours: null,
      minutes: null,
      saving: false
    };
  },
  computed: {
    currentTotalSoldTime() {
      const { unit_time_minutes, quantity } = this.lineItem;
      return unit_time_minutes * quantity;
    },
    newTotalSoldTime() {
      const { quantity } = this.lineItem;
      return this.overrideMinutes * quantity;
    },
    overrideMinutes() {
      if (
        (isFalsy(this.hours) && isFalsy(this.minutes)) ||
        this.hours < 0 ||
        this.minutes < 0
      ) {
        return null;
      }
      return this.hours * 60 + Number(this.minutes);
    },
    title() {
      return `Edit Total Sold Task Time for Invoice #${this.invoiceId}`;
    },
    lineItemLink() {
      return this.lineItem.links.pricebook_link;
    },
    isFormValid() {
      return !isFalsy(this.overrideMinutes) && this.overrideMinutes >= 0;
    }
  },
  methods: {
    ...mapActions(["setLineItemSoldTime"]),
    handleSubmit() {
      this.saving = true;
      this.setLineItemSoldTime({
        link: this.lineItem.links.time_override,
        unit_time_minutes_override: this.overrideMinutes
      })
        .then(() => {
          window.notify.success(
            "The sold time for this invoice was successfuly updated."
          );
          this.$emit("hide-modal");
        })
        .finally(() => (this.saving = false));
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep(.form-cont) {
  background: var(--angel-blue);
  box-shadow: var(--box-shadow);
  border-radius: 3px;
}
::v-deep(.time-input) {
  width: 40px;
  margin-bottom: -8px !important;
  :deep(input) {
    padding: 6px !important;
  }
}
::v-deep(.current-time-label) {
  margin-top: 11px;
}
</style>
